import * as Yup from 'yup';
import { ContractPaymentForm } from 'src/utils/constants/contracts';

export default Yup.object().shape({
  paymentForm: Yup.string().required('SCHEMA_ERRORS.REQUIRED_FIELD'),
  bankAccountId: Yup.string().when('paymentForm', {
    is: ContractPaymentForm.AUTOMATIC_DEBIT,
    then: schema => schema.required('SCHEMA_ERRORS.REQUIRED_FIELD'),
    otherwise: schema => schema.nullable()
  }),
  secondaryBankAccountId: Yup.string().nullable(),
  cardId: Yup.string().when('paymentForm', {
    is: ContractPaymentForm.CREDIT_CARD,
    then: schema => schema.required('SCHEMA_ERRORS.REQUIRED_FIELD'),
    otherwise: schema => schema.nullable()
  })
});

